







































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import toCurrency from '@/shared/directive/toCurrency';
import Pagination from '@/domain/pagination.entity';
import PaymentFileService from '@/domain/payment/service/payment-file-service';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import PaymentFile from './payment-file.view.vue';
import Header from './header.json';

@Component({
  components: {
    VbPagination,
  },
})
export default class PaymentFileDatatable extends Vue {
  @Prop({
    required: true,
  })
  paymentFiles!: PaymentFile[];

  @Prop({
    type: Boolean,
    default: false,
  })
  loading!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    type: Pagination,
    required: true,
  })
  pagination!: Pagination;

  header: any[] = Header;

  currencyFormat: any = toCurrency;

  href: string = '';

  fileName: string = '';

  formatCompetence(competence: string): string {
    return DateFormat.localDateToLocal(competence);
  }

  openFile(id: string): void {
    PaymentFileService.downloadPaymentFile(this.businessUnitId, id)
      .then(({ data }) => {
        if (data.contentType === 'application/pdf') {
          this.openPdfNewTab(data.file)
          return
        }
        const downloadContent: string = `data:${data.contentType};base64,${data.file}`
        this.href = downloadContent;
        this.fileName = data.fileName;
        this.$nextTick(() => {
          const { download }: any = this.$refs;
          download.click();
        })
      }).catch(VbSnackbarService.handleHttpError)
  }

  openPdfNewTab(base64: string): void {
    const pdfWindow: any = window.open('')

    pdfWindow.document.write(
      `<iframe width='100%' height='100%' src='data:application/pdf;base64, ${
        encodeURI(base64)}'></iframe>`,
    )
  }

  updateTable(pagination: Pagination): void {
    this.$emit('update:pagination', pagination)
  }

  updateSortBy(sortBy: string[]): void {
    this.updateTable(new Pagination({ ...this.pagination, sortBy }))
  }

  updateSortDesc(sortDesc: string[]): void {
    this.updateTable(new Pagination({ ...this.pagination, sortDesc }))
  }
}

